module.exports = __webpack_public_path__ + "static/media/cancel_calendar.73645fbd.svg";